import moment from 'moment';
import React from 'react';
import styled from 'styled-components';

const INTERVALS = {
  DAY_1: '1 Day',
  MIN_1: '1 Min',
  MIN_5: '5 Min',
  MIN_60: '60 Min',
  UNKNOWN: '???'
};

const FlashingItem: React.FunctionComponent<{ item: { text: any, signal: number }, isFlashing: boolean}> = ({ item: order }) => {
  const { text } = order;

  const words = text.split(' ');

  const model = words[3].replace(/c$/i, ''); // remove legacy reference to c
  const lastChar = model[model.length - 1];
  const formattedModel = lastChar === '0' ? model.slice(0, -2) : model.slice(0, -1);

  const interval = () => {
    if (lastChar === '0') {
      return INTERVALS.MIN_60;
    }

    if (lastChar === '5') {
      return INTERVALS.MIN_5;
    }

    if (lastChar === '1') {
      return INTERVALS.MIN_1;
    }

    if (lastChar === 'D') {
      return INTERVALS.DAY_1;
    }
    return INTERVALS.UNKNOWN;
  };

  const price = parseFloat(words[7].slice(0, -1)).toFixed(2);
  const date = moment(text.time).format('MM-DD-YYYY');
  const time24 = moment(text.time).format('HH:mm:ss');
  const orderSide = order.signal > 0 ? 'BUY' : order.signal > -2 ? 'SELL' : 'STOP';

  return (
    <OuterContainer>
      <Border signal={order.signal} />
      <FlashingItemContainer>
        <Message>
          <ModelContainer>
            <Side signal={order.signal}>{orderSide}</Side>
            <Model>{`${formattedModel} ${interval()} Model @ `}</Model>
            <Price signal={order.signal}>{price}</Price>
          </ModelContainer>
          <DateContainer>
            <Date>{date}</Date>
            <Time>{time24}</Time>
          </DateContainer>
        </Message>
      </FlashingItemContainer>
    </OuterContainer>
  );
};

const Date = styled.span`
  color: ${({ theme }) => theme.core.textColor};
  font-size: 10px;
  margin-right: 4px;
`;

const ModelContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  white-space: nowrap;
`;

const DateContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  text-align: end;
  margin-left: 7.5px;
  white-space: nowrap;
`;

const Time = styled(Date)`
  margin: 0;
`;

const Price = styled.span<{ signal: number}>`
  color: ${({ theme, signal }) => {
    if (signal > 0) {
      return theme.template.green.dark;
    } else if (signal > -2) {
      return theme.template.red.dark;
    } else {
      return theme.template.blue.dark;
    }
  }};
  margin-left: 2px;
`;

const Model = styled.span`
  color: ${({ theme }) => theme.core.textColor};
`;

const Side = styled.span<{ signal: number}>`
  color: ${({ theme, signal }) => {
    if (signal > 0) {
      return theme.template.green.dark;
    } else if (signal > -2) {
      return theme.template.red.dark;
    } else {
      return theme.template.blue.dark;
    }
  }};
  padding: 0 2px 0 7.2px;
`;

const FlashingItemContainer = styled.div`
  margin-bottom: 4px;
  color: ${({ theme }) => theme.core.textColor};
  border-radius: 3px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  z-index: 1;
  font-size: 12px;
  padding: 7px;
  width: 100%;
  background-color: ${({ theme }) => theme.core.darkBackground};
`;

const Message = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  padding-right: 12px;
  justify-content: space-between;
  align-items: center;

  ${Side} {
    margin-right: 2px;
  }
`;

const Border = styled.div<{ signal: number}>`
  border-radius: 2.5px;
  height: inherit;
  margin-bottom: 4px;
  width: 4.8px;
  background-color: ${({ theme, signal }) => {
    if (signal > 0) {
      return theme.template.green.dark;
    } else if (signal > -2) {
      return theme.template.red.dark;
    } else {
      return theme.template.blue.dark;
    }
  }};
`;

const OuterContainer = styled.div`
  display: grid;
  justify-content: space-between;
  grid-template-columns: auto 1fr;
  width: 100%;
`;

export default FlashingItem;
